import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import FormEventHandlers from '../../../../libs/utility/formeventhandlers/FormEventHandlers';
import { BUTTON_TYPE } from '../../../components/button/constants';
import Loadable from '../../../components/loadable/Loadable';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import IRSTypeFormSubmitPopup from '../irstypeformsubmitpopup/IRSTypeFormSubmitPopup';
import { FORM1094C_LOADING_STATES, FORM1094C_STATES_MESSAGE_MAP } from './constants';
import { getFormPreloadedData, onDependentFieldChangeGetValues, save1094cForm } from './Form1094cSaga';
import { componentKey, setOnDependentFields, setSuccessfullySubmitted1094c, setTempFormFieldsList, setToCreateFormData } from './Form1094cSlice';

export default function Form1094c({
    isPopupOpen,
    handlePopupClose = () => {},
    selectedForm = {},
    year,
    payer,
    onFinalSubmitCb = () => {},
    isEditModeOn,
}){
    useGarbageCollector(componentKey);

    const { loadingState, tempFormFieldsList, toCreateFormData, formsPreLoadedData, userInteractionPopupWResponseObj, onDependentFields, successfullySubmitted1094c } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        const tempToCreateFormData = {
            selectedForm: {
                ...selectedForm,
                FormId: "Form1094C",
            },
            selectedPayer: {
                ...payer,
            },
            selectedYear: Number(year),
        }
        dispatch(setToCreateFormData(tempToCreateFormData));
        let additionalPreloadedPayload = {};
        if(isEditModeOn){
            additionalPreloadedPayload = {
                formRecordId: tempToCreateFormData?.selectedPayer?.PayerDetailId,
                isFormEditMode: isEditModeOn,
            }
        }
        dispatch(getFormPreloadedData({
            formId: tempToCreateFormData?.selectedForm?.FormId,
            payerId: tempToCreateFormData?.selectedPayer?.PayerDetailId,
            year: tempToCreateFormData?.selectedYear,
            formsPreLoadedData: formsPreLoadedData,
            getFormFieldsFlag: true,
            toCreateFormData: tempToCreateFormData,
            ...additionalPreloadedPayload,
        }));
    }, []);

    useEffect(() => {
        FormEventHandlers.updateDependentFieldsArr(tempFormFieldsList, (reverseDependencyMap) => dispatch(setOnDependentFields(reverseDependencyMap)));
    }, [tempFormFieldsList]);

    useEffect(() => {
        if(successfullySubmitted1094c){
            onFinalSubmitCb();
            handlePopupClose();
            setSuccessfullySubmitted1094c(false);
        }
    }, [successfullySubmitted1094c]);

    const handleFormSubmit = () => {
        const validationResult = FormEventHandlers.handleNextBtnClick("", tempFormFieldsList, true, (newTempFormFieldsList) => dispatch(setTempFormFieldsList(newTempFormFieldsList)), () => dispatch(addNotifications({ heading: "There are some errors in the fields.", message: "To save form, please resolve these errors" })));
        if (validationResult) {
            const finalFormObject = tempFormFieldsList.reduce((obj, item) => {
                obj[item.Name] = item.inputValue || null;
                return obj;
            }, {});
            let formData = {
                ...finalFormObject,
            };

            dispatch(save1094cForm({
                formData: formData,
            }));
        }
    }
    
    return <>
        <Loadable
            currentState={loadingState.state}
            loadingStates={[FORM1094C_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING]} isNewLoadable={true}
            messageMap={FORM1094C_STATES_MESSAGE_MAP}
            preserveChildMount={true}
        >
            <IRSTypeFormSubmitPopup
                title={`Form 1094-C (Transmittal of Employer)`}
                isPopupOpen={isPopupOpen}
                onCloseCb={handlePopupClose}
                confirmationButtonProps={{
                    onConfirmationCb: () => handleFormSubmit(),
                    confirmationButtonText: "Save",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => handlePopupClose(),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                tempFormFieldsList={tempFormFieldsList}
                toCreateFormData={toCreateFormData}
                formsPreLoadedData={formsPreLoadedData}
                userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}
                onChangeCb={(e, field) => FormEventHandlers.inputValueChange(e, field, tempFormFieldsList, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), toCreateFormData, onDependentFields, (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), true)}
                onBlurCb={(e, inputValidationResult, field) => FormEventHandlers.handleOnBlur(e, field, tempFormFieldsList, inputValidationResult, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)))}
                dropdownOnSelectCb={(name, selectedOption, field) => FormEventHandlers.handleDropDownValueChange(name, selectedOption, tempFormFieldsList, toCreateFormData, onDependentFields, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), (onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData)), () => { }, true)}
                handleIRSFormSubmitCb={handleFormSubmit}
                dispatchNotificationCb={(heading, message, variant) => addNotifications({
                    heading: heading,
                    message: message,
                    variant: TOASTER_VARIANT[variant]
                })}
                loadingState={loadingState}
                loaderLoadingStates={[FORM1094C_LOADING_STATES.CONFIGURATIONS_LOADING, FORM1094C_LOADING_STATES.SAVE_FORM_LOADING]}
                loaderMessageMap={FORM1094C_STATES_MESSAGE_MAP}
            />
        </Loadable>
    </>
}